export const getNetworkMask = (maskBits: number): string => {
  if (maskBits < 0 || maskBits > 32) return "";

  const maskOctets: Array<number> = [];

  for (let i = 0; i < 4; i++) {
    const bitsToSet = Math.min(maskBits, 8);
    const octetValue = 256 - Math.pow(2, 8 - bitsToSet);
    maskOctets.push(octetValue);
    maskBits -= bitsToSet;
  }

  return maskOctets.join(".");
};

export const getBinaryValueFromAddress = (ipAddress: string) =>
  ipAddress
    .split(".")
    .map((part) => parseInt(part, 10).toString(2).padStart(8, "0"))
    .join("");

export const calcSubnets = ({
  ipAddress,
  maskAddress,
  networkPrefixBits,
  subnetCount,
  addressCount,
}: {
  ipAddress: string;
  maskAddress: string;
  networkPrefixBits: number;
  subnetCount: number;
  addressCount: number;
}): Array<Array<string>> => {
  const output: Array<Array<string>> = [];
  let subnet = BigInt(0);
  const subnetMax = subnetCount > 1024 ? 1024 : subnetCount;
  const ipBin = getBinaryValueFromAddress(ipAddress);
  const maskBin = getBinaryValueFromAddress(maskAddress);

  for (let j = 0; j < subnetMax; j++) {
    if (j === 0) subnet = BigInt("0b" + ipBin) & BigInt("0b" + maskBin);
    else subnet += BigInt(addressCount + 2);

    const subnetDec = convertIPaddress(subnet.toString(2), "binary");

    const addrNet = subnetDec;
    const addrStart = convertIPaddress(
      (subnet + BigInt(1)).toString(2),
      "binary",
    );
    const addrEnd = convertIPaddress(
      (subnet + BigInt(addressCount)).toString(2),
      "binary",
    );
    const addrBroad = convertIPaddress(
      (subnet + BigInt(addressCount + 1)).toString(2),
      "binary",
    );

    output.push([
      `${subnetDec}/${networkPrefixBits}`,
      addrStart,
      addrEnd,
      addrNet,
      addrBroad,
    ]);
  }

  if (subnetCount > 1024) {
    output.push(["Subnet list shortened to 1024", "", "", "", ""]);
  }

  return output;
};

export const convertIPaddress = (
  input: string,
  inputType: "decimal" | "binary" | "bits" | "octet",
): string => {
  let output = "";

  switch (inputType) {
    case "decimal": {
      const inputSegments = input.split(".");

      for (let i = 0; i < 4; i++) {
        const segment = inputSegments[i];
        if (!segment) return "";
        const segm = Number(+segment >>> 0).toString(2);
        output += "00000000".substring(0, 8 - segm.length) + segm;
      }

      return output;
    }
    case "binary": {
      const inputExt =
        "00000000000000000000000000000000".substring(0, 32 - input.length) +
        input;

      for (let i = 0; i < 4; i++) {
        output += parseInt(inputExt.substring(i * 8, i * 8 + 8), 2);
        if (i < 3) output += ".";
      }

      return output;
    }
    case "bits": {
      let bMask = "";

      for (let i = 1; i <= 32; i++) {
        if (i <= +input) {
          bMask += "1";
        } else {
          bMask += "0";
        }
      }

      return convertIPaddress(bMask, "binary");
    }
    case "octet": {
      const oct = (+input * 1).toString(16).toUpperCase();
      return "00".substring(0, 2 - oct.length) + oct;
    }
  }
};
